import React, { useState, useMemo } from 'react'
import { useLocale } from '../contexts/LocaleContext'
import { blogPosts, categories } from '../data/blogPosts'
import BlogPostCard from './BlogPostCard'
import BlogSearch from './BlogSearch'
import BlogFilters from './BlogFilters'

function Blog() {
  const { t } = useLocale()
  const [searchQuery, setSearchQuery] = useState('')
  const [selectedCategory, setSelectedCategory] = useState('all')

  // Filter and search blog posts
  const filteredPosts = useMemo(() => {
    return blogPosts.filter(post => {
      const matchesSearch = post.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           post.excerpt.toLowerCase().includes(searchQuery.toLowerCase()) ||
                           post.tags.some(tag => tag.toLowerCase().includes(searchQuery.toLowerCase()))
      
      const matchesCategory = selectedCategory === 'all' || post.category === selectedCategory
      
      return matchesSearch && matchesCategory
    })
  }, [searchQuery, selectedCategory])

  return (
    <section className="blog-section">
      <div className="container">
        <div className="blog-header">
          <h1>{t.blog.title}</h1>
          <p className="lead">{t.blog.lead}</p>
        </div>

        <div className="blog-controls">
          <BlogSearch 
            value={searchQuery}
            onChange={setSearchQuery}
            placeholder={t.blog.search}
          />
          <BlogFilters 
            categories={categories}
            selectedCategory={selectedCategory}
            onCategoryChange={setSelectedCategory}
            t={t}
          />
        </div>

        <div className="blog-grid">
          {filteredPosts.length > 0 ? (
            filteredPosts.map(post => (
              <BlogPostCard key={post.id} post={post} t={t} />
            ))
          ) : (
            <div className="no-results">
              <p>{t.blog.noArticlesFound}</p>
              <button 
                className="btn"
                onClick={() => {
                  setSearchQuery('')
                  setSelectedCategory('all')
                }}
              >
                {t.blog.clearFilters}
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default Blog
